interface ValidationValues {
  amountToPay: { min: number; max: number };
  tipAmount: { min: number };
  note: { max: number };
}

const VALIDATION_VALUES_BY_CURRENCY: Record<string, ValidationValues> = {
  USD: { amountToPay: { min: 0.5, max: 1_000 }, tipAmount: { min: 0.5 }, note: { max: 250 } },
  AED: { amountToPay: { min: 2.0, max: 3_500 }, tipAmount: { min: 2.0 }, note: { max: 250 } },
};

export const getValidationValues = (currency: string): ValidationValues => {
  return VALIDATION_VALUES_BY_CURRENCY[currency.toUpperCase()];
};

export const validateAmount = (
  amount: number,
  currency: string
): { isValid: boolean; errorKey?: string } => {
  const values = getValidationValues(currency);
  if (
    isNaN(amount) ||
    amount < values.amountToPay.min ||
    amount > values.amountToPay.max
  ) {
    return {
      isValid: false,
      errorKey: "charge.validation.amountRange",
    };
  }
  return { isValid: true };
};

export const validateTip = (
  tip: number,
  currency: string
): { isValid: boolean; errorKey?: string } => {
  const values = getValidationValues(currency);
  if (isNaN(tip) || (tip !== 0 && tip < values.tipAmount.min)) {
    return {
      isValid: false,
      errorKey: "charge.validation.tipMin",
    };
  }
  return { isValid: true };
};

export const validateTotalAmount = (
  amount: number,
  tip: number,
  currency: string
): { isValid: boolean; errorKey?: string } => {
  const values = getValidationValues(currency);
  const totalAmount = amount + tip;

  if (totalAmount > values.amountToPay.max) {
    return {
      isValid: false,
      errorKey: "charge.validation.totalAmountMax",
    };
  }
  return { isValid: true };
};
